import { FC } from 'react';

import { Icon, Typography, Tooltip, Tag, Space } from '@sravni/react-design-system';
import { ThumbUp } from '@sravni/react-icons';

import { TooltipIcon } from '../../../../components/UI/Icons/TooltipIcon';
import { FILTER_NAMES } from '../../../../constants/reviews';
import { sendSqueezeOffEvent, sendSqueezeOnEvent } from '../../../../helpers/analyticsEvents';
import { toUpperFirstSymbol } from '../../../../helpers/common';
import { IReviewsSqueeze } from '../../../../interfaces/reviews';
import { IListHeaderProps } from '../../index';

interface ISqueezeProps extends Pick<IListHeaderProps, 'filters' | 'handleChange'> {
  items: IReviewsSqueeze['items'];
}

export const SqueezeBlock: FC<ISqueezeProps> = ({ items, filters, handleChange }) => {
  const filterValue = filters[FILTER_NAMES.SQUEEZE_IDS] || [];

  const handleSqueezeChange = (value: string, label: string, isActive: boolean) => {
    const currValue = Array.isArray(filterValue) ? filterValue : [filterValue];

    const newValue = currValue.includes(value) ? currValue.filter((v) => v !== value) : [...currValue, value];

    handleChange(newValue, FILTER_NAMES.SQUEEZE_IDS);

    if (isActive) {
      sendSqueezeOffEvent(label);
    } else {
      sendSqueezeOnEvent(label);
    }
  };

  return (
    <div>
      <Space size={4}>
        <Typography.Text strong className={'h-mb-16'}>
          Часто упоминают
        </Typography.Text>
        <Tooltip content="Мы использовали нейросеть, чтобы проанализировать отзывы за 180 дней и выделить самые важные темы — так проще отфильтровать нужные комментарии">
          <Icon icon={<TooltipIcon />} />
        </Tooltip>
      </Space>
      <Space size={12} wrap>
        {items.map((item) => {
          const value = item.vectorId.toString();
          const isActive = filterValue.includes(value);
          const isHighRate = item.highRatingCount / item.count > 0.5;

          const handleClick = () => {
            handleSqueezeChange(value, item.text, isActive);
          };

          return (
            <Tag key={`squeeze-${value}`} size={36} active={isActive} onClick={handleClick}>
              {isHighRate && <Icon icon={<ThumbUp />} color={isActive ? 'blue' : 'green'} />}
              {toUpperFirstSymbol(item.text)}
              <Typography.Text className={isActive ? '' : 'h-color-D40'}>{item.count}</Typography.Text>
            </Tag>
          );
        })}
      </Space>
    </div>
  );
};
